export const CHECK_EMAIL_REQUEST = 'CHECK_EMAIL_REQUEST'
export const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS'
export const CHECK_EMAIL_FAIL = 'CHECK_EMAIL_FAIL'

export const CHECK_EMAIL_RESET = 'CHECK_EMAIL_RESET'

export const CHECK_SECONDARY_EMAIL_REQUEST = 'CHECK_SECONDARY_EMAIL_REQUEST'
export const CHECK_SECONDARY_EMAIL_SUCCESS = 'CHECK_SECONDARY_EMAIL_SUCCESS'
export const CHECK_SECONDARY_EMAIL_FAIL = 'CHECK_SECONDARY_EMAIL_FAIL'